import { isGeographyAllowed } from '../discovery/policy.js';
export function directPurchaseMethods(policy, input) {
    const provider = policy.providers.moonpay;
    if (input.onrampEnabled !== true ||
        input.directPurchaseEnabled !== true ||
        !provider.enabled ||
        !input.ownedWallet ||
        !input.tokenSupported ||
        input.cashD6 === null ||
        !/^\d{1,20}$/.test(input.cashD6) ||
        BigInt(input.cashD6) >= BigInt(policy.settings.buy_action_threshold_usdc_d6))
        return [];
    return ['apple_pay', 'google_pay', 'card'].filter((method) => {
        const selected = provider.methods[method];
        return (selected.enabled &&
            selected.surfaces.includes(input.surface) &&
            input.deviceMethods.includes(method) &&
            input.providerMethods.includes(method) &&
            isGeographyAllowed(selected.geography, input.country, input.subdivision));
    });
}
